var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "_12_Cloud",
    "data-name": "12 Cloud"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,150a25,25,0,0,1-25-25V25a25,25,0,0,1,50,0V125A25,25,0,0,1,256,150Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256,512a25,25,0,0,1-25-25V387a25,25,0,0,1,50,0V487A25,25,0,0,1,256,512Z",
    style: {
      opacity: 0.4
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125,281H25a25,25,0,0,1,0-50H125a25,25,0,0,1,0,50Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M487,281H387a25,25,0,0,1,0-50H487a25,25,0,0,1,0,50Z",
    style: {
      opacity: 0.1
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M348.63,188.37A25,25,0,0,1,331,145.69L401.66,75A25,25,0,1,1,437,110.34l-70.71,70.71A24.93,24.93,0,0,1,348.63,188.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.66,444.34A25,25,0,0,1,75,401.66L145.69,331a25,25,0,0,1,35.36,35.36L110.34,437A24.94,24.94,0,0,1,92.66,444.34Z",
    style: {
      opacity: 0.7
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.37,188.37a24.93,24.93,0,0,1-17.68-7.32L75,110.34A25,25,0,1,1,110.34,75l70.71,70.71a25,25,0,0,1-17.68,42.68Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.34,444.34A24.94,24.94,0,0,1,401.66,437L331,366.31A25,25,0,0,1,366.31,331L437,401.66a25,25,0,0,1-17.68,42.68Z",
    style: {
      opacity: 0.2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.001a204c581b20f218c8025b01e28680.svg";
export { ForwardRef as ReactComponent };